/**
 * Tarjetas resumen
 *
 */
import React from 'react'
import { Row, Col, Statistic, Skeleton } from 'antd'
import Api from '../../../Api'
import { Panel, Divider } from '../../../components'
import Exception from '../../../Exception'

export function TarjetasResumen(props) {
  const [loading, setLoading] = React.useState(false)
  const [solicitudesPendientes, setSolicitudesPendientes] = React.useState([])
  const [solicitudesProcesadas, setSolicitudesProcesadas] = React.useState([])
  const [pagosPendientes, setPagosPendientes] = React.useState([])
  const [pagosRealizados, setPagosRealizados] = React.useState([])

  /**
   * fetch
   *
   */
  const fetch = async (desde, hasta) => {
    try {
      setLoading(true)

      const response = await Api.query.list({
        pendientes: {
          model: 'CxpOrdenPago',
          attributes: [
            [{ fn: 'sum', params: ['$dImporteOriginal$'] }, 'importe'],
          ],
          include: [{ as: 'moneda', required: true, attributes: [['sCodigo', 'nombre']] }],
          where: {
            iIdProveedor: Api.getProviderId(),
            sEstado: 'PENDIENTE',
            iActivo: true,
          },
          group: ['iIdMoneda'],
        },

        procesadas: {
          model: 'CxpOrdenPago',
          attributes: [
            [{ fn: 'sum', params: ['$dImporteOriginal$'] }, 'importe'],
          ],
          include: [{ as: 'moneda', attributes: [['sCodigo', 'nombre']] }],
          where: {
            iIdProveedor: Api.getProviderId(),
            $and: [
              { dFechaIngresado: { $gte: desde } },
              { dFechaIngresado: { $lte: hasta } },
            ],
            sEstado: { $ne: 'PENDIENTE' },
            iActivo: true,
          },
          group: ['iIdMoneda'],
        },

        pagosPendientes: {
          model: 'TesPago',
          attributes: [
            [{ fn: 'sum', params: ['$dImporte$'] }, 'importe'],
          ],
          include: [{ as: 'moneda', attributes: [['sCodigo', 'nombre']] }],
          where: {
            iIdProveedor: Api.getProviderId(),
            $and: [
              { dKernelFechaRegistro: { $gte: desde } },
              { dKernelFechaRegistro: { $lte: hasta } },
            ],
            sEstado: 'PENDIENTE',
            iActivo: true,
          },
          group: ['iIdMoneda'],
        },

        pagosRealizados: {
          model: 'TesPago',
          attributes: [
            [{ fn: 'sum', params: ['$dImporte$'] }, 'importe'],
          ],
          include: [{ as: 'moneda', attributes: [['sCodigo', 'nombre']] }],
          where: {
            iIdProveedor: Api.getProviderId(),
            $and: [
              { dFechaPagado: { $gte: desde } },
              { dFechaPagado: { $lte: hasta } },
            ],
            sEstado: 'PAGADO',
            iActivo: true,
          },
          group: ['iIdMoneda'],
        },
      })

      setSolicitudesPendientes(response.data.pendientes || [])
      setSolicitudesProcesadas(response.data.procesadas || [])
      setPagosPendientes(response.data.pagosPendientes || [])
      setPagosRealizados(response.data.pagosRealizados || [])
      setLoading(false)
    } catch (error) {
      setLoading(false)
      Exception.load(error).show()
    }
  }

  /**
   * onDatesChanged
   *
   */
  React.useEffect(() => {
    if (props.desde && props.hasta) fetch(props.desde, props.hasta)
  }, [props.desde, props.hasta])

  /**
   * Item
   *
   * @param {*} param0
   */
  const Item = ({ title, data }) => (
    <Panel style={{ height: '100%' }}>
      <h4>{title}</h4>
      {data.length && data.map(item => (
        <Statistic
          key={item.moneda.nombre}
          title={item.moneda.nombre}
          value={item.importe}
          prefix={<span>$</span>}
          precision={2}
        />
      ))}
    </Panel>
  )

  const rows = [
    [
      {
        title: 'SOLICITUDES PENDIENTES',
        data: solicitudesPendientes,
      },
      {
        title: 'SOLICITUDES PROCESADAS',
        data: solicitudesProcesadas,
      },
    ],
    [
      {
        title: 'PAGOS PROGRAMADOS',
        data: pagosPendientes,
      },
      {
        title: 'PAGOS APLICADOS',
        data: pagosRealizados,
      },
    ]
  ]

  return (
    <div>
      {rows.map((row, idx) =>
        <div key={idx.toString()}>
          <Row gutter={16} style={{ display : 'flex' }}>
            {row.map(col =>
              <Col key={col.title} span={6} style={{ flex: 1 }}>
                {loading ? (
                  <Panel children={<Skeleton rows={2} active />} />
                ) : (
                  <Item
                    title={col.title}
                    data={col.data}
                  />
                )}
              </Col>
            )}
          </Row>

          <Divider />
        </div>
      )}
    </div>
  )
}


